import * as React from 'react';
import { connect } from 'react-redux';

import BaseCcmCampaignPage from '../../BaseCcmCampaignPage';
import CampaignZalandoOutfit from 'modules/organizations/components/campaign-zalando-outfit/CampaignZalandoOutfit';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./ccm-campaign-outfits-page.i18n.json'));

import type { Campaign, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  campaign: Campaign
};

type Props = OwnProps & StateProps;

const MSG_KEY = 'ccm_campaign_outfits_page';

const CcmCampaignOutfitsPage: React.FC<Props> = ({
  campaign,
  params
}): JSX.Element => (
  <div className="ccm-campaign-outfits-page">
    <BaseCcmCampaignPage
      campaignType={campaign.campaignType ?? 'ccm'}
      params={params}
      documentTitle={__t(`${MSG_KEY}.document_title`)}
      pageType="outfits"
    >
      <CampaignZalandoOutfit campaignId={params.id} />
    </BaseCcmCampaignPage>
  </div>
);


const mapStateToProps = ({ campaignBrief }): StateProps => ({
  campaign: campaignBrief.brief
});

export default connect(mapStateToProps)(CcmCampaignOutfitsPage);
